import classnames from 'classnames'
import React, { FC } from 'react'

export interface MessageProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {}

export const Message: FC<MessageProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <h1
      className={classnames(
        'text-md font-semibold text-primary text-center',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
}
